import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "small-table"
}
const _hoisted_2 = { class: "buttons" }

import DivisionTable from '@/components/tables/DivisionTable.vue';
import DivisionFormModal from '@/components/modals/DivisionFormModal.vue';
import { DivisionItem } from '@/services/entities/DivisionItem';
import { useSettingsStore } from '@/stores/setting';
import { onMounted, reactive } from 'vue';
import { useVfm } from 'vue-final-modal';
import Loader from '@/components/util/Loader.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'DivisionView',
  setup(__props) {

const settingsStore = useSettingsStore();
const divisionModalId = Symbol("divisionModalId");
const vfm = useVfm();

onMounted(async () => {
  await settingsStore.loadDivisions();
})

const state = reactive({
  value: {} as DivisionItem,
});

async function create() {
  await settingsStore.createDivision(state.value);
  vfm.close(divisionModalId)
  state.value = {} as DivisionItem;
  await settingsStore.loadDivisions();
}

async function edit() {
  await settingsStore.updatingDivision(state.value);
  vfm.close(divisionModalId)
  state.value = {} as DivisionItem;
}

function showEditDivision(id: number) {
  state.value = settingsStore.getDivisions.find(a => a.id == id);
  vfm.open(divisionModalId);
}

async function closeModal() {
  vfm.close(divisionModalId);
  state.value = {} as DivisionItem;
  settingsStore.loadRates();
}

async function deleteDivision(id: number) {
  await settingsStore.deleteDivision(id);
  state.value = {} as DivisionItem;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(settingsStore).getDivisionsLoaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(DivisionTable, {
            data: _unref(settingsStore).getDivisions,
            onEdit: showEditDivision,
            onDelete: deleteDivision
          }, null, 8, ["data"]),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("button", {
              class: "accent",
              onClick: _cache[0] || (_cache[0] = () => _unref(vfm).open(_unref(divisionModalId)))
            }, [...(_cache[1] || (_cache[1] = [
              _createElementVNode("b", null, "+", -1),
              _createTextVNode("Add division", -1)
            ]))])
          ])
        ]))
      : (_openBlock(), _createBlock(Loader, { key: 1 })),
    _createVNode(DivisionFormModal, {
      value: state.value,
      "modal-id": _unref(divisionModalId),
      onClose: closeModal,
      onCreate: create,
      onEdit: edit
    }, null, 8, ["value", "modal-id"])
  ], 64))
}
}

})